<template>
  <div class="my_patten_style">
    <div
      class="list"
      :class="{ active: style_type_number === item.data.styleType }"
      v-for="(item, index) in style_list"
      :key="index"
      :style="{
        backgroundColor: backgroundColor
      }"
      @click="changeId(item, index)"
    >
      <p v-if="$store.state.app.module_Data.data.pc_widgets_infor.showLogo !== 'true' && index === 0 && !childType">{{$t('view_back_top_edit_103')}}</p>
      <img v-else :src="item.imgUrl" />
      <span class="activeIcon el-icon-check"></span>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_patten_style',
  props: {
    moduleData: {},
    styleList: {
      type: Array,
      default: null
    },
    styleType: {
      type:String,
      default:''
    },
    childType:{
      type:Boolean,
      default:false
    },
    filterOpen: {
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      module_data: this.$store.state.app.module_Data.data.pc_widgets_infor,
      style_type_number: this.styleType,
      style_list:[]
    };
  },
  methods: {
    changeId(item, index) {
      if(!this.childType){
        this.templet.changeTypeStyle(item,this.pc_widgets_infor,true);
      }
      this.style_type_number = item.data.styleType;
      this.$emit('typeStyleChange', item.data.styleType);
    },
    createStyeList(){
      if(!this.filterOpen) {
        this.style_list = this.styleList
        return
      }
      this.style_list = this.styleList.filter(e=>{
        if(e.typeStyle === this.style_type){
          return e
        }
      })
      console.log(this.style_list)
    }
  },
  computed: {
    backgroundColor(){
      return this.$store.state.myRender.common.theme_color;
    },
    pc_widgets_infor() {
      return this.$store.state.app.module_Data.data.pc_widgets_infor;
    },
    style_type(){
      return this.$store.state.app.module_Data.data.pc_widgets_infor.showLogo === 'true' ? 'logo' : 'noLogo';
    }
  },
  watch:{
    style_type(val){
      this.createStyeList()
    },
    style_type_number(val) {
      this.$emit('update:styleType', val)
    },
    styleType(val) {
      this.style_type_number = val
    },
  },
  mounted() {
    this.createStyeList()
    console.log(111, this.style_type_number);
  },
};
</script>

<style scoped type="text/css" lang="scss">
.my_patten_style {
   padding: 0 15px;
      position: relative;
   display: table-cell;
  .list {
    text-align: center;
    line-height: 58px;
    width: 140px;
    height: 58px;
    position: relative;
    overflow: hidden;
    float: left;
    cursor: pointer;
    display: inline-block;
    margin-top: 10px;
    border: 1px solid #e7e7eb;
    border-radius: 2px;
    img {
      width: 100%;
    }
    p {
      width: 100%;
      height: 100%;
      background: #fff;
    }
    .activeIcon {
      display: none;
      width: 18px;
      height: 16px;
      color: #fff;
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: #5874d8;
      line-height: 22px;
      font-size: 12px;
      padding: 0 3px;
      border-top-left-radius: 100%;
    }
  }
  .list.active {
    border: 1px solid #5874d8;
    .activeIcon {
      display: block;
    }
  }
  .list:nth-child(odd) {
    margin-right: 18px;
  }
  .list:nth-child(1),
  .list:nth-child(2) {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_pattern_style/index.vue